import { createUseStyles } from "react-jss";
import { getSpacing } from "../../theme/Mixins";

export default createUseStyles({
    topNavigation: {
        alignItems: "center",
        boxSizing: "border-box",
        composes: "top-navigation",
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        left: 0,
        marginBottom: ({ theme }) => theme.TopNavigationPosition === "wrapper" && getSpacing(theme, 10, theme.QuestionSpacing?.PageHeader),
        paddingRight: ({ theme }) => theme.TopNavigationPosition === "floating" && 10,
        position: ({ theme }) => theme.TopNavigationPosition === "floating" && "absolute",
        right: 0,
        top: ({ theme }) => theme.TopNavigationPosition === "floating" && 10,
        zIndex: 2,
        gap: "10px",
    },
    languageSelector: {
        composes: "top-navigation__language-selector",
        fontSize: "13px",
        zIndex: 11,
        marginTop: "-8px",
    },
});
